import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { VERIFY_COUPON, VERIFY_COUPON_ERROR, VERIFY_COUPON_SUCCESS } from '../../actions.js';

function* verifyCoupon({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/digital/redemptions`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: VERIFY_COUPON_SUCCESS,
        payload: response?.data,
      });
    } else {
      // The failure reason (expired / already redeemed / wrong outlet) is what the operator
      // needs to read, so it is surfaced both inline on the form and as a toast.
      const message = response?.response?.data?.message;
      cogoToast.error(`${message}`);

      yield put({
        type: VERIFY_COUPON_ERROR,
        payload: message,
      });
    }
  } catch (error) {
    yield put({ type: VERIFY_COUPON_ERROR, payload: error?.message });
  }
}

export function* watchVerifyCoupon() {
  yield takeEvery(VERIFY_COUPON, verifyCoupon);
}

function* verifyCouponSaga() {
  yield all([fork(watchVerifyCoupon)]);
}

export default verifyCouponSaga;
